export default r => r.keys().map(r);



// WEBPACK FOOTER //
// ./src/utils/importAllFromFolder.js